package com.sddamico.draftmachine

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.sddamico.draftmachine.ds.DmType
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

// Brand faces (body `body` base registration now lives in the design system's DmBase).
val HeadingFontFamily = DmType.heading
val BodyFontFamily = DmType.body

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(2.5.cssRem)
        .fontWeight(FontWeight.Bold)
        .fontFamily(*HeadingFontFamily)
        .color(SitePalette.text)
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .color(SitePalette.textSecondary)
}

val CardStyle = CssStyle.base {
    Modifier
        .backgroundColor(SitePalette.surface)
        .border(1.px, LineStyle.Solid, SitePalette.border)
        .borderRadius(8.px)
        .padding(1.5.cssRem)
}

val PrimaryButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(SitePalette.primary)
            .color(Colors.White)
            .borderRadius(8.px)
            .padding(topBottom = 0.75.cssRem, leftRight = 1.5.cssRem)
            .fontWeight(FontWeight.SemiBold)
            .cursor(Cursor.Pointer)
            .transition(Transition.of("background-color", 150.ms))
    }
    hover {
        Modifier.backgroundColor(SitePalette.primaryHover)
    }
}
